import imgLoader from '../components/img-loader';
import endPoint from '../utils/end-points';
import { dataExist } from '../utils/Utils';

require('es6-promise').polyfill();
const axios = require('axios');

const socialFeed = (() => {
  const config = {
    triggers: [...document.querySelectorAll('.js-socialFeed')],
    loadingCN: '-loading',
    errorCN: '-error',
  };

  const handleLoadingTiles = (trigger) => {
    const areAllImgsLoaded = setInterval(() => {
      // check if all images have been loaded
      // then remove the loading class to avoid unnecessary page renderings
      if (trigger.querySelectorAll('img.loaded').length === trigger.children.length) {
        setTimeout(() => {
          // remove loading class that adds the fancy flashes to the container
          trigger.classList.remove(config.loadingCN);
          clearTimeout(stopCheckingIfAllImgsAreLoaded); // eslint-disable-line no-use-before-define
          // remove label that says the feed is loading
          trigger.removeAttribute('aria-label');
        }, 800); //  800 = fadeIn delay
        // stop interval
        clearInterval(areAllImgsLoaded);
      }
    }, 250);

    // remove interval after a little to avoid using memory if there's been an issue
    const stopCheckingIfAllImgsAreLoaded = setTimeout(() => {
      // stop interval
      clearInterval(areAllImgsLoaded);
      // remove loading class that adds the fancy flashes to the container
      trigger.classList.remove(config.loadingCN);
    }, 120000); // it shouldn't take more than 120s to load the img from instagram
  };

  const handleMarkup = (trigger, arr) => {
    const container = trigger;
    const children = [...container.children];

    arr.forEach((insta, index) => {
      // Update the markup for all children except the ones that aren't empty
      // (There are some elements that don't depend on Instagram's API and are already rendered)
      if (children[index].childElementCount === 0) {
        children[index].innerHTML = `
          ${dataExist(insta, 'link') ? `
            <a
              href="${insta.link}"
              rel="noopener"
              class="socialFeed__link"
              aria-label="Bilder från instagramflöde"
            >
              ${insta.media_type === 'IMAGE' ? `
                <div class="imgLoader js-imgLoadTrigger socialFeed__image" data-href="${insta.media_url}" data-alt="Bilder från instagramflöde" role="presentation"></div>
              ` : `
                <video poster="${insta.media_url}" autoPlay muted loop width="100%">
                  <source type="video/mp4" src="${insta.media_url}" />
                </video>`}
            </a>
          ` : ''}
        `;
      }
    });

    // launch img ajax loader
    imgLoader.reset();

    handleLoadingTiles(trigger);
  };

  const handleFeed = (trigger) => {
    axios.get(endPoint.feed)
      .then((response) => {
        // handle success
        if (response.status === 200) {
          // trigger.classList.remove(config.loadingCN);
          handleMarkup(trigger, response.data);
        }
      })
      .catch(() => {
        // remove loading class
        trigger.classList.remove(config.loadingCN);
        // add error class, this will add a beautiful gradient bg
        trigger.classList.add(config.errorCN);
      });
  };

  const build = () => {
    config.triggers.forEach((trigger) => {
      handleFeed(trigger);
    });
  };

  const init = () => {
    if (config.triggers.length > 0) {
      build();
    }
  };

  return {
    init,
  };
})();

export default socialFeed.init();
